import React from "react";
import { useLocation, Outlet } from "react-router-dom";
import { useSnapshot } from "valtio";
import classnames from "classnames";
import { ToastContainer } from "react-toastify";

import { setIsMobile, store } from "./store";

import Header from "./Header";
import SidebarContent, { menuItems } from "./SidebarContent";
import Footer from "./Footer";

import NotAuthorizationPage from "./NotAuthorizationPage";
import { getAuthorizationStates } from "./StyledSidebarMenu";

import "./layout.css";
import { useSelector } from "react-redux";

function getIdFromMenuItems(path: string, foodCourt?: any) {
    let find = { id: "" };
    try {
        let menu = menuItems(() => {}, foodCourt === true);
        const searchTree = (fn: any): any => (obj: any) =>
            Array.isArray(obj)
                ? obj.length === 0
                    ? null
                    : searchTree(fn)(obj[0]) || searchTree(fn)(obj.slice(1))
                : fn(
                      obj,
                      () => searchTree(fn)(obj?.subMenu || []),
                      () => obj
                  );

        const findId = (target: any, obj: any) =>
            searchTree((node: any, next: any, found: any) =>
                node.link === target ? found() : next()
            )(menu);
        find = findId(path, menu);
        if (path === "/compte" || path === "" || path === "/test-auto") {
            find = { id: "idCompte" };
        }
    } catch (error) {
        find = { id: "" };
    }

    return find;
}
export function getPathAuthorization(
    path: string,
    authorizationList: any,
    foodCourt?: any
) {
    let jsonPath = getIdFromMenuItems(path, foodCourt);
    let auto = getAuthorizationStates(jsonPath?.id, authorizationList);
    return auto;
}

export default function VerticalLayout() {
    const location = useLocation();
    const authorizationList = useSelector(
        (state: any) => state.global.infoUser.profileAuthorization
    );
    let matchHomeRoute = "/home" === location.pathname;
    let matchLoginRoute = "/login" === location.pathname;
    let matchCompteRoute = "/compte" === location.pathname;
    let matchTestAutoRoute = "/test-auto" === location.pathname;
    let matchProjectRoute = "/project" === location.pathname;
    let matchApplicationRoute =
        "/kiosk-peripheral-setting" === location.pathname;
    const { collapsed, isMobileBurgerButtonClicked, limitToast } = useSnapshot(
        store
    );

    const handleResize = () => {
        if (window.innerWidth <= 992) {
            setIsMobile(true);
        } else {
            setIsMobile(false);
        }
    };

    // create an event listener
    React.useEffect(() => {
        window.addEventListener("resize", handleResize);
    });

    function OutletAuthorization({ path }: any) {
        let foodCourt = useSelector((state: any) => state.global.isFoodCourt);
        let auto = getPathAuthorization(path, authorizationList, foodCourt);
        return auto?.Consult === true ? (
            <Outlet />
        ) : path === "/test-auto" ? (
            <Outlet />
        ) : (
            <NotAuthorizationPage />
        );
    }
    return (
        <React.Fragment>
            <div
                className={classnames("vertical-menu__clz", {
                    "d-none":
                        matchHomeRoute ||
                        matchLoginRoute ||
                        matchCompteRoute ||
                        matchTestAutoRoute ||
                        (collapsed === true &&
                            isMobileBurgerButtonClicked === true),
                })}
            >
                <SidebarContent />
            </div>
            <div
                className={classnames({
                    "d-none": matchHomeRoute || matchLoginRoute,
                })}
            >
                <Header />
            </div>
            {collapsed && isMobileBurgerButtonClicked ? (
                <div
                    className="ml-2 main-content"
                    style={{ minHeight: "calc(100vh - 67.5px)" }}
                >
                    <OutletAuthorization path={location.pathname} />
                </div>
            ) : collapsed ? (
                <div
                    className="main-content"
                    style={{
                        minHeight: "calc(100vh - 67.5px)",
                        backgroundColor: "#f3f3f9",
                        marginLeft: "4rem",
                    }}
                >
                    <OutletAuthorization path={location.pathname} />
                </div>
            ) : (
                <div
                    className={
                        matchHomeRoute || matchCompteRoute || matchTestAutoRoute
                            ? "ml-0 main-content"
                            : "main-content__clz"
                    }
                    style={{
                        minHeight: "calc(100vh - 67.5px)",
                        backgroundColor: "#f3f3f9",
                    }}
                >
                    <OutletAuthorization path={location.pathname} />
                </div>
            )}
            <Footer />
            {matchProjectRoute || matchApplicationRoute ? (
                <ToastContainer limit={limitToast} />
            ) : null}
        </React.Fragment>
    );
}
